import React from "react";

const RichText = ({ html, ...rest }) => {
  return (
    <div {...rest} dangerouslySetInnerHTML={{ __html: html?.replace(/\n/g, "<br />") }} />
  );
}

export default RichText;